// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"2f3665cc","118":"2814365d","561":"091df422","607":"2c6e6ae4","616":"1f28faa0","671":"cf2d040a","710":"277c3b22","714":"bb5a4e58","723":"44d52c13","737":"6e00b096","766":"3d707a1a","825":"d9110d92","874":"a406a80a","930":"56131ac6"}[chunkId] + ".chunk.js";
};